import { render, staticRenderFns } from "./BpIcon.vue?vue&type=template&id=9af62888&scoped=true&"
import script from "./BpIcon.vue?vue&type=script&lang=js&"
export * from "./BpIcon.vue?vue&type=script&lang=js&"
import style0 from "./BpIcon.vue?vue&type=style&index=0&id=9af62888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af62888",
  null
  
)

export default component.exports